import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  AUTHORIZED_CHECK,
  AUTHORIZED_LOGIN,
  AUTHORIZED_LOGOUT,
  AUTHORIZED_REGISTRATION,
  FORGOT_PASSWORD,
} from './actions';
import {
  LOCAL_STORAGE_AUTHORIZED_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT,
} from '../../configs/names';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { AUTHORIZED_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import { createOperationStateReducer } from '../../utils/getCrudConfig';
import AuthorizedUserDTO from '../../dto/AuthorizedUserDTO';
import AuthorizedDTO from '../../dto/AuthorizedDTO';

const getToken = () => {
  try {
    return window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY) || null;
  } catch (e) {
    return null;
  }
};

const setStorageAuthorized = token => {
  window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY, token);
};
const clearStorageAuthorized = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY);
};

const getUser = () => {
  try {
    const result = window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_KEY);
    return result ? JSON.parse(result) : {};
  } catch (e) {
    return {};
  }
};

const token = getToken() || null;
// if (!client.id || !token) {
if (!token) {
  clearStorageAuthorized();
}

const initialState = {
  loggedIn: Boolean(token),
  // loggedIn: true,
  loginProcess: false,
  authorizedData: getUser(),
  token,
  loadingAuthorizedCheck: Boolean(token),
  loadingForgotPassword: false,
};

const reducer = handleActions({
  ...createOperationStateReducer(AUTHORIZED_MODULE + FORGOT_PASSWORD, 'loadingForgotPassword'),
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      token: null,
      authorizedData: {},
      loggedIn: false,
      loginProcess: true,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN + SUCCESSFUL]: (state, action) => {
    const { token } = action.payload;
    setStorageAuthorized(token);
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT, new Date().getTime());
    return {
      ...state,
      token,
      authorizedData: action.payload,
      loggedIn: !!token,
      loginProcess: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGIN + FAILED]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      authorizedData: {},
      token: null,
      loggedIn: false,
      loginProcess: false,
      loadingAuthorizedCheck: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK]: (state, action) => ({
    ...state,
    loadingAuthorizedCheck: true,
  }),
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL]: (state, action) => {
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_KEY, JSON.stringify(action.payload));
    return {
      ...state,
      authorizedData: action.payload,
      loggedIn: true,
      loadingAuthorizedCheck: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED]: (state, action) => {
    clearStorageAuthorized();
    return {
      ...state,
      authorizedData: action.payload,
      token: null,
      loggedIn: false,
      loadingAuthorizedCheck: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL]: state => {
    clearStorageAuthorized();
    return {
      ...state,
      authorizedData: {},
      token: null,
      loggedIn: false,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION]: state => ({
    ...state,
    loggedIn: false,
  }),
}, initialState);

export default reducer;

export const getClientPersonalData = state => new AuthorizedUserDTO(state[AUTHORIZED_MODULE].authorizedData);

export const getAuthorizedData = createSelector([state => state[AUTHORIZED_MODULE]], state => new AuthorizedDTO(state));

export const getLoginProcess = createSelector(
  [state => state[AUTHORIZED_MODULE]],
  state => state.loginProcess || false,
);
